import { Component, Input } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-password-input-field',
    templateUrl: './password-input-field.component.html',
    standalone: true,
    imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatPasswordStrengthModule, TranslateModule]
})
export class PasswordInputFieldComponent {
    @Input() placeholder: string;
    @Input() control: AbstractControl;
    @Input() required = false;
    @Input() icon: string;
    @Input() id = '';
    @Input() passwordStrength = false;
    @Input() autocomplete = 'off';

    showPasswordText = false;
}
